export default "__VITE_ASSET__CJP5UeCq__"